import { fetchApi } from '@/config/axiosSetting';
import { IBodyPatchSubstitutionPartParams } from '@/modules/adjusterReportModules/Insurer-information/queries/patchBodySubstitutionPart/patchBodySubstitutionPartQuery.type';

export const patchBodySubstitutionPartQueryFunction = (
  params: IBodyPatchSubstitutionPartParams,
) => {
  return fetchApi.patch(
    `body/reports/${params?.id}/adjusting/substitution_parts/`,
    params?.data,
    {
      params: {
        source: params?.source,
        id: params?.id,
        part_id: params?.part_id,
      },
    },
  );
};
